<template>
	<div>
		<b-modal
			ref="modalError"
			hide-footer
			title="Erreur"
		>
			<lottie_error />
			<p class="my-4">{{ text_error }}</p>
		</b-modal>

		<b-modal ref="loaderModal"
			hide-footer
			title="Chargement...">
			<throbber />
			<p class="my-4">Veuillez patienter pendant l'enregistrement de vos données</p>
		</b-modal>

		<b-modal :size="'lg'"
			ref="previewModal"
			static="true"
			:lazy=true
			ok-only>
			<div class="embed-responsive embed-responsive-16by9">
				<video class="embed-responsive-item"
					:src="preview_path"
					ref="playerpreview"
					controls
					height="600"
					width="800"></video>
			</div>
		</b-modal>

		<ul id="image_list">
			<li v-for="(item, index) in this.values" :key="index">
				<img :src="base_url + '/public/storage/images/' + item[0]" />
				<button :disabled="title_edited" v-if="index !== 0" class="left" @click="move(index, -1)">◀&#xFE0E;</button>
				<button :disabled="title_edited" v-if="index !== values.length - 1" class="right" @click="move(index, 1)">▶&#xFE0E;</button>
				<button :disabled="title_edited" class="delete" @click="del_image(item[0], index)">❌&#xFE0E;</button>
			</li>
		</ul>
		<b-row>
			<b-col md="auto">
				<form>
					<div class="input-group mb-3">
						<input :disabled="title_edited || values.length >= max_images" id="input_newfile" name="new_file" type="file" accept="image/png,image/jpeg" @change="upload_file"  />
						<label class="upload_label"
							for="input_newfile">{{ $t("Music.import") }}</label>
						<span v-if="title_edited" class="modificationLabel button-aligned">Texte à valider avant de pouvoir éditer les images</span>
					</div>
				</form>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<form>
					<div class="flex-container">
						<div class="input-box" v-for="(item, index) in this.values" :key="index">
							<div class="form-group"
								v-if="hasTitleField">
								<label class="sentence_label">{{ $t("Images.title") }} {{ max_images === 1 ? "" : (index + 1) }}
									<span v-if="title_edited" class="modificationLabel"> {{ $t("Button.editing") }} </span>
									<input type="text"
										class="form-control no-border"
										@input="title_edited_event"
										v-model="item[1]"
										ref="inputTitle"></label>
							</div>
							<div class="form-group"
								v-if="hasTitleField && enable_position">
								<label class="sentence_label">{{ $t("Images.position") }} {{ max_images === 1 ? "" : (index + 1) }}
									<span v-if="title_edited" class="modificationLabel"> {{ $t("Button.editing") }} </span>
									<select type="text"
										class="form-control no-border"
										@input="title_edited_event"
										v-model="item[2]"
										ref="inputTitle">
										<option value="topleft">{{ $t("Images.topleft") }}</option>
										<option value="topright">{{ $t("Images.topright") }}</option>
										<option value="bottomleft">{{ $t("Images.bottomleft") }}</option>
										<option value="bottomright">{{ $t("Images.bottomright") }}</option>
									</select>

								</label>
							</div>
						</div>
					</div>
					<!--				<div class="form-group"-->
					<!--					v-if="hasSecondaryTitleField">-->
					<!--					<label class="subtitle_label"-->
					<!--						for="subtitle2">{{ $t("Ambiance.secondary_title") }}</label>-->
					<!--					<span v-if="secondarytitle_edited" class="modificationLabel"> {{ $t("Button.editing") }} </span> <input type="text"-->
					<!--					class="form-control no-border"-->
					<!--					id="subtitle2"-->
					<!--					@input="secondarytitle_edited_event"-->
					<!--					v-model="secondaryTitle" ref="inputSubtitle">-->
					<!--				</div>-->
				</form>
			</b-col>
		</b-row>

		<b-row>
			<b-col md="auto">
				<div class="valid_button">
					<button type="submit"
						v-if="this.values.length > 0"
						class="btn btn-valid"
						@click="sendDatas">{{ $t("Button.validate") }}
					</button>
				</div>
			</b-col>

			<b-col md="auto">
				<button
					class="btn btn-preview"
					:disabled="!isCompleted || title_edited"
					@click="preview"
				>{{ $t("Button.preview") }}
				</button>
			</b-col>
		</b-row>
		<!--		<div class="valid_button">-->
		<!--			<button type="submit"-->
		<!--				class="btn btn-valid"-->
		<!--				@click.prevent="sendDatas">{{ $t("Button.validate") }}-->
		<!--			</button>-->
		<!--		</div>-->

	</div>
</template>

<script>
import axios from "axios";
import {EventBus} from "../../event/event-bus";
import throbber from "@/components/ui/throbber";
import lottie_error from "@/components/ui/lottie_error";

const BASE_URL = process.env.VUE_APP_BASE_URL;

export default {
	name: "Images",
	components: {lottie_error, throbber},
	props: {
		id: Number,
		stepName: String,
		// values: Array,
		hasMusicEnable: Boolean,
		projectId: Number,
		imageId: Number,
		image_list: Array,
		groupId: String,
		stepIndex: Number,
		isCompleted: Boolean,
		isVisible: Boolean,

		title: String,
		hasTitleField: Boolean,
	},
	data() {
		return {
			base_url: process.env.VUE_APP_BASE_URL,
			text_error: "",
			values: [],
			title_edited: false,

			max_images: 1,
			enable_position: false,

			preview_path: "",
		};
	},
	computed: {},
	created() {
	},
	beforeMount() {
		this.loadData();
	},
	methods: {
		sendDatas() {
			let $this = this;
			$this.$refs.loaderModal.show();
			let bodyFormData = new FormData();
			bodyFormData.append("_method", "put");
			bodyFormData.append("image_list", JSON.stringify(this.values));

			axios.post(BASE_URL + "/public/api/stepImages/" + this.id,
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.$refs.loaderModal.hide();
				$this.title_edited = false;
				$this.secondarytitle_edited = false;
			})
			.catch(error => {
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		loadData() {
			let $this = this;

			axios.get(BASE_URL + "/public/api/stepImages/" + this.id, {
				headers: {
					"Authorization": sessionStorage.getItem("auth"),
				},
			})
			.then(function (response) {
				let data = response.data.data;

				let image_data = JSON.parse(data.image_list);
				for (let item of image_data) {
					if (item[2] === undefined) {
						item[2] = "bottomleft";
					}
				}

				$this.values = image_data;

				$this.isCompleted = data.isCompleted;

				if ($this.isCompleted) {
					EventBus.$emit("setStepImagesComplete", $this.id);
				}
				else {
					EventBus.$emit("setStepImagesNotComplete", $this.id);
				}

			}).catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		move(index, change) {
			let new_order = new Array(this.values.length).fill(undefined).map((_, i) => i);
			new_order[index] = index + change;
			new_order[index + change] = index;

			let bodyFormData = new FormData();
			bodyFormData.append("order", JSON.stringify(new_order));

			let new_values = [];
			for (let key of new_order) {
				new_values.push(this.values[key]);
			}
			this.values = new_values;

			let $this = this;
			axios.post(BASE_URL + "/public/api/stepImages/" + this.id + "/reorder",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				// $this.loadData();
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
			});

			// reload
		},
		del_image(name, index) {
			let bodyFormData = new FormData();
			bodyFormData.append("value", name);
			this.$refs.loaderModal.show();
			let $this = this;
			axios.post(BASE_URL + "/public/api/stepImages/" + this.id + "/delimage",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.loadData();
				$this.$refs.loaderModal.hide();
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
			});
		},
		upload_file() {
			let files = document.getElementById("input_newfile").files;

			if (!files.length) {
				return 0;
			}

			let bodyFormData = new FormData();
			bodyFormData.append("image", files[0]);

			this.$refs.loaderModal.show();
			let $this = this;
			axios.post(BASE_URL + "/public/api/stepImages/" + this.id + "/addimage",
				bodyFormData,
				{
					headers: {
						"Content-Type": "multipart/form-data",
						"Authorization": sessionStorage.getItem("auth"),
					},
				},
			).then(function () {
				$this.loadData();
				$this.$refs.loaderModal.hide();
			})
			.catch(error => {
				$this.text_error = this.$root.$t("Errors.message_project") + error;
				$this.$refs.modalError.show();
			});
		},
		preview() {
			this.$refs.loaderModal.show();
			let $this = this;

			axios.get(BASE_URL + "/public/api/stepImages/" + this.id + "/preview",
				{
					headers: {
						"Authorization": sessionStorage.getItem("auth"),
					},
				})
			.then(response => {
				let data = response.data;

				this.$refs.loaderModal.hide();

				this.preview_path = BASE_URL + "/public/storage/videos/generated/" + data.url + "#" + new Date().getTime();
				this.$refs.previewModal.show();
			}).catch(error => {
				this.$refs.loaderModal.hide();
				this.text_error = this.$root.$t("Errors.message_project") + error;
				this.$refs.modalError.show();
			});
		},
		title_edited_event() {
			this.title_edited = true;
		},
		secondarytitle_edited_event() {
			this.secondarytitle_edited = true;
		},
	},
};
</script>

<style scoped>

.modificationLabel {
	font-size: 14px;
	color: orange;
}

#image_list {
	list-style: none;
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	align-items: stretch;
	gap: 10px;
	min-height: 120px;
}

#image_list li {
	width: 120px;
	height: 120px;
	border-radius: var(--big-border-radius);
	border: 1px solid grey;
	box-sizing: border-box;
	position: relative;
	overflow: hidden;
}

#image_list button {
	border: 0;
	position: absolute;
	visibility: hidden;
}

#image_list li:hover button {
	visibility: visible;
}

#image_list button.left {
	bottom: 0;
	left: 0;
	border-radius: 0 5px 0 0;
}

#image_list button.right {
	bottom: 0;
	right: 0;
	border-radius: 5px 0 0 0;
}

#image_list button.delete {
	top: 0;
	right: 0;
	border-radius: 0 0 0 5px;
	background: var(--color-main-action);
	color: white;
}

#image_list img {
	max-width: 100px;
	max-height: 100px;
	display: block;
	margin: 0 auto;
	position: relative;
	top: 50%;
	transform: translateY(-50%);
}

.btn {
	border-radius: var(--small-border-radius);
}

.btn-valid {
	background-color: var(--color-validation);
	border-color: var(--color-validation);
	color: var(--text-validation);
}

#input_newfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}

.upload_label {
	font-weight: 400;
	color: var(--text-secondary-action);
	background-color: var(--color-validation);
	display: inline-block;
	cursor: pointer;
	padding: 6px 12px;
	font-size: 16px;
	border-radius: 4px;

}

#input_newfile:focus + .upload_label,
#input_newfile + .upload_label:hover {
	background-color: var(--color-validation);
}

#input_newfile:disabled + .upload_label {
	cursor: default;
	opacity: .7;
}

.flex-container {
	display: flex;
	flex-wrap: wrap;
	justify-content: flex-start;
	gap: 0 50px;
	margin-top: 20px;
}

.btn-preview {
	background-color: var(--color-main-action);
	border-color: var(--color-main-action);
	color: var(--text-secondary-action);
}
.input-box {
	width: 300px;
}

.input-box input {
	width: 300px;
}

.button-aligned {
	line-height: 30px;
	padding: 0 20px;
}
</style>
